import { useEffect, useState } from "react";
import { getProducts } from "../../helpers/getProducts";

export const useFetchCards = () => {

    const [state, setState] = useState({ total: 0, data: [] });

    useEffect(() => {
        getProducts().then(cards => {
            setState(cards);
        });
    }, []);

    return { state, setState };
}